import React, { useState } from "react";
import Table from "./Components/Table";
import { toast, ToastContainer } from "react-toastify";
import PopUp from "./Components/PopUp";
import { CheckPlan, ExpirePlan, GetPolicies } from "./API/SBDriveServices";
import useAuthCheck from "../../CheckUser/userAuthCheck";

const ProgramDeactivation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [cpr, setCpr] = useState("");
 const [open, setOpen] = useState(false);
  const [policies, setPolicies] = useState([
    // More policies can be added here
  ]);

  const [plan, setPlan] = useState({});

  const Search = async () => {
    
    var policiesList = await GetPolicies(cpr, setIsLoading);
    if (policiesList.length === 0) {
      toast.error("No Policies found", {
        style: {
          background: "#ffcccc",
          color: "black",
          fontWeight: "bold",
        },
      });
    } else {
      const filteredPolicies = policiesList.filter(
        (p) =>
          p.ProductName === "Motor" &&
          p.PolicyStatus === "ACTIVE POLICY" &&
          p.PlanName !== "TPL"
      );
      setPolicies(filteredPolicies);
    }
  };

  // const GetPolicies = async () => {
  //   const url = process.env.REACT_APP_WEB_API + "policy/GetPolicies";
  //   const data = {
  //     Cpr: cpr,
  //     Channel: "",
  //   };
  //   setIsLoading(true);

  //   //var token = tokenDetails.access_token;
  //   try {
  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(data),
  //     });

  //     if (!response.ok) {
  //       const errorDetails = await response.json();
  //       toast.error(errorDetails.message, {
  //         style: {
  //           background: "#ffcccc",
  //           color: "black",
  //           fontWeight: "bold",
  //         },
  //       });
  //       throw new Error("Failed to retrieve policy details");
  //     }

  //     const result = await response.json();
  //     setIsLoading(false);
  //     return result;
  //   } catch (error) {
  //     setIsLoading(false);
  //     toast.error("Something went wrong", {
  //       style: {
  //         background: "#ffcccc",
  //         color: "black",
  //         fontWeight: "bold",
  //       },
  //     });
  //     console.error("Error", error);
  //   }
  // };

  const openPolicy = async (policy) => {
    var checkPlan = await CheckPlan(policy, setIsLoading);
    if(checkPlan.statusCode == 200){
        setOpen(true);
        setPlan({
          PlanNumber: policy,
          StartDate: checkPlan.StartDate,
          EndDate: checkPlan.EndDate
        });
        console.log(policy);
    }
    else{
      console.log(policy);
    }
    
  };

  const closePolicy = () => {
    setPlan({});
    setOpen(false);

  };

  const expireNow = async () =>{
    closePolicy();
    var expireData = await ExpirePlan(plan.PlanNumber, setIsLoading);
    if(expireData.statusCode == 200){
      toast.success(expireData.Message);
    }
    else{
      setPlan({});
      toast.error("No Plan Found or an Error occurred while deactivating plan", {
        style: {
          background: "#ffcccc",
          color: "black",
          fontWeight: "bold",
        },
      });
    }
  }
  return (
    <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow">
      <div className="px-4 py-5 sm:px-6">
        {/* Content goes here */}
        <form className="mt-5 sm:flex sm:items-center">
          <div className="w-full sm:max-w-xs">
            <input
              onChange={(e) => setCpr(e.target.value)}
              id="cpr"
              name="cpr"
              type="number"
              placeholder="CPR"
              value={cpr}
              aria-label="Email"
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
            />
          </div>
          <button
            type="button"
            onClick={Search}
            className="mt-3 inline-flex w-full items-center justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:ml-3 sm:mt-0 sm:w-auto"
          >
            Search
          </button>
        </form>
        {/* We use less vertical padding on card headers on desktop than on body sections */}
      </div>
      <div className="px-4 py-5 sm:p-6">
        {/* Content goes here */}

        {isLoading ? (
          <div className="text-center">
            <div className="flex items-center justify-center h-auto bg-gray-100">
              <div className="w-16 h-16 border-4 border-blue-500 border-dotted rounded-full animate-spin text-center m-4"></div>
            </div>
          </div>
        ) : (
          <Table policies={policies} openPolicy={openPolicy} />
        )}
      </div>
      <ToastContainer />
      <PopUp open={open} closePolicy={closePolicy} plan={plan} expireNow={expireNow} />
    </div>
    
  );
};

export default ProgramDeactivation;
